@if (volumeSummary) {
  <div class="indicators">
    <div>
      <mat-icon matTooltip="{{ 'density_peak_volume_description' | transloco }}">
        leaderboard
      </mat-icon>
      &nbsp;{{ volumeSummary.densityPeak.toFixed(0) }}
    </div>

    <div>
      <mat-icon matTooltip="{{ 'positive_volume_in_m3' | transloco }}">
        add_box
      </mat-icon>
      &nbsp;{{ volumeSummary.positiveVolumeMoved.toFixed(0) }}
    </div>

    <div>
      <mat-icon matTooltip="{{ 'negative_volume_in_m3' | transloco }}">
        indeterminate_check_box
      </mat-icon>
      &nbsp;{{ volumeSummary.negativeVolumeMoved.toFixed(0) }}
    </div>
  </div>
}
